export default "__VITE_ASSET__C8ggFCHl__"